import { navLinks } from "@/mocks/loveHelperData";

export default function Footer() {
  return (
    <footer className="bg-secondary-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#home" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-heart-3-fill text-lg"></i>
              </span>
              <span className="font-display text-lg text-primary-600">恋爱辅助器</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              专注《恋爱辅助器》漫画的角色介绍、CP 关系与感情线解析，为每一位追漫的读者提供清晰实用的内容整理。
            </p>
            <div className="mt-5 flex gap-3">
              {["ri-weibo-line", "ri-whatsapp-line", "ri-mail-line", "ri-wechat-line"].map((icon) => (
                <a
                  key={icon}
                  href="#contact"
                  aria-label="互动平台"
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-lg text-primary-600 transition-colors hover:bg-primary-100"
                >
                  <i className={icon}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-bold text-foreground-900">快速导航</h4>
            <ul className="mt-4 space-y-3">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <a href={`#${l.id}`} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-bold text-foreground-900">内容栏目</h4>
            <ul className="mt-4 space-y-3">
              <li><a href="#characters" className="text-sm text-foreground-600 hover:text-primary-600">角色图鉴</a></li>
              <li><a href="#cps" className="text-sm text-foreground-600 hover:text-primary-600">CP 关系</a></li>
              <li><a href="#timeline" className="text-sm text-foreground-600 hover:text-primary-600">感情线时间轴</a></li>
              <li><a href="#guide" className="text-sm text-foreground-600 hover:text-primary-600">追漫指南</a></li>
              <li><a href="#faq" className="text-sm text-foreground-600 hover:text-primary-600">常见问题</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 恋爱辅助器漫画粉丝站 · 角色与感情线解析，仅供参考与交流
          </p>
          <p className="text-xs text-foreground-500">以热爱为名，为每一位追漫的读者服务</p>
        </div>
      </div>
    </footer>
  );
}